import React from 'react';
import styles from './TermsAndConditions.module.css';

const TermsAndConditions = () => {
  const termsSections = [
    {
      id: 1,
      title: '1. Introducción',
      content:
        'Al utilizar la plataforma Megaloto, aceptas estos términos y condiciones. Si no estás de acuerdo con ellos, no deberías usar nuestros servicios.',
    },
    {
      id: 2,
      title: '2. Uso de la plataforma',
      content:
        'La plataforma está diseñada para usuarios mayores de 18 años. Es responsabilidad del usuario garantizar el cumplimiento de las leyes locales al participar.',
    },
    {
      id: 3,
      title: '3. Políticas de pago',
      content:
        'Los pagos realizados son seguros y cumplen con las normativas internacionales. Los reembolsos están sujetos a evaluación en casos específicos.',
    },
    {
      id: 4,
      title: '4. Responsabilidad del usuario',
      content:
        'El usuario debe garantizar que la información proporcionada sea precisa. Megaloto no se hace responsable de errores en los datos registrados.',
    },
    {
      id: 5,
      title: '5. Modificaciones en los términos',
      content:
        'Nos reservamos el derecho de actualizar estos términos en cualquier momento. Se notificará a los usuarios con cambios significativos.',
    },
    {
      id: 6,
      title: '6. Contacto',
      content:
        'Para cualquier consulta sobre estos términos, puedes escribirnos a soporte@megaloto.com o visitar la sección de ayuda en nuestro sitio web.',
    },
  ];

  return (
    <div className={styles.terms}>
      <h1>Términos y Condiciones</h1>
      <p>
        Por favor, lee cuidadosamente los siguientes términos y condiciones antes de utilizar la plataforma Megaloto. Si tienes preguntas, no dudes en contactarnos.
      </p>
      {termsSections.map((section) => (
        <div key={section.id} className={styles.section}>
          <h2>{section.title}</h2>
          <p>{section.content}</p>
        </div>
      ))}
      <div className={styles.confirmation}>
        <input type="checkbox" id="agree" />
        <label htmlFor="agree">Acepto los términos y condiciones</label>
      </div>
    </div>
  );
};

export default TermsAndConditions;
